import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref, Transition as _Transition, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "summary-top-intro"
}
const _hoisted_2 = { class: "summary-top-intro-content" }
const _hoisted_3 = { class: "my-report-top-calendar-wrapper" }
const _hoisted_4 = { class: "my-report-top-calendar" }
const _hoisted_5 = { class: "my-report-item calendar" }
const _hoisted_6 = { class: "my-report-calendar-legend" }
const _hoisted_7 = { class: "legend-label" }
const _hoisted_8 = { class: "my-reports" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "my-report-header" }
const _hoisted_11 = { class: "my-report-header-date" }
const _hoisted_12 = {
  key: 0,
  class: "my-report-header-body-condition"
}
const _hoisted_13 = { class: "my-report-header-body-condition-text" }
const _hoisted_14 = {
  key: 0,
  class: "my-report-header hospital"
}
const _hoisted_15 = { class: "my-report-hospita-list" }
const _hoisted_16 = { class: "my-report-header-hospital-visit-text" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "my-report-item body-condition"
}
const _hoisted_20 = { class: "item-unrecordable" }
const _hoisted_21 = { class: "item-unrecordable-text" }
const _hoisted_22 = {
  key: 1,
  class: "my-report-item"
}
const _hoisted_23 = { class: "item-unrecorded" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "item-unrecorded-note" }
const _hoisted_27 = { class: "my-report-item" }
const _hoisted_28 = { class: "item-top" }
const _hoisted_29 = { class: "item-title" }
const _hoisted_30 = { class: "item-title-text" }
const _hoisted_31 = {
  key: 0,
  class: "item-recorded"
}
const _hoisted_32 = { class: "item-daily-note" }
const _hoisted_33 = { class: "row-text" }
const _hoisted_34 = { class: "row-bottom" }
const _hoisted_35 = { class: "row-bottom-date" }
const _hoisted_36 = { class: "item-daily-note-more-wrapper" }
const _hoisted_37 = {
  key: 1,
  class: "item-unrecordable"
}
const _hoisted_38 = { class: "item-unrecordable-text" }
const _hoisted_39 = {
  key: 2,
  class: "item-unrecordable"
}
const _hoisted_40 = { class: "item-unrecordable-text" }
const _hoisted_41 = {
  key: 3,
  class: "item-unrecorded"
}
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "item-unrecorded-note" }
const _hoisted_44 = { class: "my-report-item feeling" }
const _hoisted_45 = { class: "item-top" }
const _hoisted_46 = { class: "item-title" }
const _hoisted_47 = { class: "item-title-text" }
const _hoisted_48 = {
  key: 0,
  class: "item-feeling"
}
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "row-text" }
const _hoisted_51 = {
  key: 1,
  class: "item-unrecordable"
}
const _hoisted_52 = { class: "item-unrecordable-text" }
const _hoisted_53 = {
  key: 2,
  class: "item-unrecordable"
}
const _hoisted_54 = { class: "item-unrecordable-text" }
const _hoisted_55 = {
  key: 3,
  class: "item-unrecorded"
}
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = { class: "item-unrecorded-note" }

import dayjs from "dayjs";
import "dayjs/locale/ja";

import { onMounted, computed, ref, reactive } from "vue";
import { processing, processend } from "@/utils/view";
import router from "@/router";

import MyCalendar from "@/models/myReport/myCalendar";
import Calendar from "@/views/base/Calendar.vue";
import ErrorDialog from "@/views/base/CommonMessage.vue";

// 日付のローカライズ
type CalendarData = {
  date: Date;
  iconUrl: string;
};

// 月変更データ
type MonthChangeData = {
  year: number;
  month: number;
  yearMonth?: string;
};

// 体調
type BodyCondition = {
  date: string;
  displayName: string;
  iconValue: number;
};

// 症状・こころノートデータ
type DailyNote = {
  id: string;
  checked: boolean;
  content: string;
  date: string;
  categoryClass: string;
  categoryLabel: string;
};

// 日々の気持ち
type DailyFeeling = {
  date: string;
  iconValue: number;
};

// 病院受診データ
type HospitalVisit = {
  date: string;
  id: number;
};

// ---- Constants & Variables ------------------------------
const _MAX_DISPLAY_COUNT = 10; // 各項目の最大表示件数


export default /*@__PURE__*/_defineComponent({
  __name: 'MyCalendar',
  setup(__props) {

dayjs.locale("ja");

// ---- Types ----------------------------------------------

// カレンダーデータ
const yearMonth = ref<string>(dayjs().format("YYYY-MM")); // 表示中の月
const selectedDate = ref<string>(dayjs().format("YYYY-MM-DD")); // 選択された日付
// 表示データ
const isDataStored = ref<boolean>(false); // データ取得済みフラグ
const initialReadFlag = ref<boolean>(true); // 初回閲覧フラグ
const bodyConditionItems = ref<Array<BodyCondition>>([]); // 体調データ
const dailyNoteItems = ref<Array<DailyNote>>([]); // 症状・こころノート
const hospitalVisitItems = ref<HospitalVisit[]>([]); // 病院受診データ
const dailyFeelings = ref<Array<DailyFeeling>>([]); // 気持ちデータ

// 体調アイコン
const urlMap: Record<number, string> = {
  1: "/server/necs/images/body_condition_terrible_active.svg",
  2: "/server/necs/images/body_condition_poor_active.svg",
  3: "/server/necs/images/body_condition_normal_active.svg",
  4: "/server/necs/images/body_condition_good_active.svg",
  5: "/server/necs/images/body_condition_excellent_active.svg",
};

const feelingMap: Record<number, { icon: string; label: string }> = {
  1: { icon: "/server/necs/images/icon_feeling_1.png", label: "前向き" },
  2: { icon: "/server/necs/images/icon_feeling_2.png", label: "嬉しい" },
  3: { icon: "/server/necs/images/icon_feeling_3.png", label: "楽しい" },
  4: { icon: "/server/necs/images/icon_feeling_4.png", label: "ワクワク" },
  5: { icon: "/server/necs/images/icon_feeling_5.png", label: "穏やか" },
  6: { icon: "/server/necs/images/icon_feeling_6.png", label: "充実" },
  7: { icon: "/server/necs/images/icon_feeling_7.png", label: "自信" },
  8: { icon: "/server/necs/images/icon_feeling_8.png", label: "貢献感" },
  9: { icon: "/server/necs/images/icon_feeling_9.png", label: "不安" },
  10: { icon: "/server/necs/images/icon_feeling_10.png", label: "無力感" },
  11: { icon: "/server/necs/images/icon_feeling_11.png", label: "もやもや" },
  12: { icon: "/server/necs/images/icon_feeling_12.png", label: "イライラ" },
  13: { icon: "/server/necs/images/icon_feeling_13.png", label: "寂しい" },
  14: { icon: "/server/necs/images/icon_feeling_14.png", label: "恐い" },
};
// ---- Dialogs --------------------------------------------
// エラーダイアログ関連情報
const sessionErr = ref(false);
let errorDialogSet = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialogSet.message = message;
    errorDialogSet.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialogSet.show = false;
    errorDialogSet.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// --- Event Handlers -------------------------------------------------------
async function onCloseIntro() {
  initialReadFlag.value = true; // 初回閲覧フラグ解除

  const myCalendar = new MyCalendar();
  const [_model, _response, err] = await myCalendar.setCalendarHiddenFlag();

  // エラー判定
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return { dailyNotes: [], dailyFeelings: [] };
  }
}

// 月変更イベントハンドラ
async function onMonthChange(data: MonthChangeData) {
  yearMonth.value = dayjs(data.yearMonth).format("YYYY-MM");
  await set(); // データ再取得
}

// 日付選択イベントハンドラ
async function onDateSelect(date: string) {
  selectedDate.value = date;
  await set(); // データ再取得
}

// 診察ノート表示
function onClickViewClinicNote(id: number) {
  router.push({
    name: "ClinicNote",
    params: { hospitalVisitId: id },
  });
}

// 記録画面へ遷移
function onClickRecordCondtion() {
  router.push({
    name: "home",
    query: { date: selectedDate.value },
  });
}

// 記録画面へ遷移
function onClickRecordSymptom() {
  router.push({
    name: "home",
    query: {
      date: selectedDate.value,
      tab: "symptom",
    },
  });
}

// 記録画面へ遷移
function onClickRecordFeeling() {
  router.push({
    name: "home",
    query: {
      date: selectedDate.value,
      tab: "feeling",
    },
  });
}

// 症状・こころノートもっと見るボタン押下
function onDailyNoteMore() {
  router.push({
    name: "MyReportDailyNote",
    params: {
      yearMonth: dayjs().format("YYYY-MM"),
    },
    query: {
      returnTab: "calendar",
      returnRoute: "MyReport",
    },
  });
}

// --- Functions ------------------------------------------------------------

// アイコンURL変換
function convertUrl(value: number): string {
  return urlMap[value] ?? "";
}

// 気持ちアイコン
function getFeelingIcon(value: number): string {
  return feelingMap[value].icon;
}

// 気持ちテキスト
function getFeelingLabel(value: number): string {
  return feelingMap[value].label;
}

// 表示データセット
async function set() {
  isDataStored.value = false;

  // カレンダーデータ取得
  const myCalendar = new MyCalendar();
  const [_model, response, err] = await myCalendar.getData(
    yearMonth.value,
    selectedDate.value
  );

  // エラー判定
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return;
  }

  // データセット
  initialReadFlag.value = response.data.calendarHiddenFlag; // 初回閲覧フラグセット
  hospitalVisitItems.value = response.data.hospitalVisits; // 病院受診データ
  bodyConditionItems.value = response.data.dailyConditions; // 体調データ
  dailyNoteItems.value = response.data.dailyNotes; // 症状・こころノート
  dailyFeelings.value = response.data.dailyFeelings; // 気持ちデータ

  isDataStored.value = true;
}

// 日付フォーマット
function formatDate(date: dayjs.Dayjs | string | null, fmt: string) {
  return date ? dayjs(date).format(fmt) : "";
}

// Vue Lifecycle Hooks ---------------------------------------------------
onMounted(async () => await set());

// カレンダーデータ
const calendar = computed<Array<CalendarData>>(() => {
  return bodyConditionItems.value.map((item) => ({
    date: dayjs(item.date).toDate(),
    iconUrl: convertUrl(item.iconValue),
  }));
});
// 選択日付の体調
const selectedDateBodyCondition = computed<string>(() => {
  const condition = bodyConditionItems.value.find(
    (item) => item.date === selectedDate.value
  );
  return condition ? condition.displayName : "";
});
// 病院受診日
const underlinedDates = computed<Array<string>>(() => {
  return hospitalVisitItems.value.map((item) => item.date);
});
// 選択日付の病院受診データ
const hospitalVisitDates = computed<Array<HospitalVisit>>(() => {
  return hospitalVisitItems.value.filter(
    (item) => item.date === selectedDate.value
  );
});
// 選択日のアイコン設定
const feelingStatus = computed(() => {
  const ymd = dayjs(selectedDate.value).format("YYYY-MM-DD");

  // 選択された日付のデータをcalendarから探す
  const data = calendar.value.find(
    (item) => dayjs(item.date).format("YYYY-MM-DD") === ymd
  );
  if (!data) return null;

  // iconUrlからァイル名を得る
  const fileName = data.iconUrl.split("/").pop();
  if (!fileName) return null;

  // ファイル名から状態を抽出
  const match = fileName.match(/body_condition_(.+?)_active/);
  if (!match) return null;

  return match[1];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!initialReadFlag.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("img", { src: "/server/necs/images/light_bulb.svg" }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("myreport_calendar_message_intro")), 1)
          ]),
          _createElementVNode("img", {
            onClick: onCloseIntro,
            class: "summary-top-intro-close",
            src: "/server/necs/images/close_black_24dp.png"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Calendar, {
            dayIcons: calendar.value,
            underlinedDates: underlinedDates.value,
            onMonthChange: onMonthChange,
            onDateSelect: onDateSelect
          }, null, 8, ["dayIcons", "underlinedDates"]),
          _createElementVNode("div", _hoisted_6, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "legend-line" }, null, -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("myreport_calendar_label_hospital_visit")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "my-report-top-calendar-circle" }, null, -1)),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (isDataStored.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(formatDate(selectedDate.value, "YYYY年M月D日(ddd)")), 1),
                  (selectedDateBodyCondition.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['my-report-header-body-condition-icon', feelingStatus.value])
                        }, null, 2),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(selectedDateBodyCondition.value), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (hospitalVisitDates.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hospitalVisitDates.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.id,
                            class: "my-report-header-hospital-visit"
                          }, [
                            _createElementVNode("p", _hoisted_16, [
                              _createTextVNode(_toDisplayString(_ctx.$t("myreport_calendar_message_hospital_visit")) + " ", 1),
                              (hospitalVisitDates.value.length > 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t("myreport_calendar_message_hospital_visit_count", {
                    count: index + 1,
                  })), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (onClickViewClinicNote(item.id)),
                              class: "my-report-header-hospital-visit-button"
                            }, [
                              _cache[2] || (_cache[2] = _createElementVNode("img", { src: "/server/necs/images/icon_link_hospital_visits.svg" }, null, -1)),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("myreport_calendar_button_view_clinicnote")), 1)
                            ], 8, _hoisted_18)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!selectedDateBodyCondition.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (
              _unref(dayjs)(selectedDate.value).isBefore(_unref(dayjs)().subtract(6, 'day'), 'day') ||
              _unref(dayjs)(selectedDate.value).isAfter(_unref(dayjs)(), 'day')
            )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("myreport_calendar_message_notrecord_condition")), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("p", {
                                class: "item-unrecorded-text pc-only",
                                innerHTML: 
                  _ctx.$t('myreport_calendar_messsage_norecord_hospital_visit_pc')
                
                              }, null, 8, _hoisted_24),
                              _createElementVNode("p", {
                                class: "item-unrecorded-text sp-only",
                                innerHTML: 
                  _ctx.$t('myreport_calendar_messsage_norecord_hospital_visit_sp')
                
                              }, null, 8, _hoisted_25),
                              _createElementVNode("button", {
                                class: "item-unrecorded-button",
                                onClick: onClickRecordCondtion
                              }, _toDisplayString(_ctx.$t("myreport_calendar_button_norecord_hospital_visit_note")), 1),
                              _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("myreport_calendar_message_norecord_symptom_note")), 1)
                            ])
                          ]))
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("myreport_calendar_label_symptom")), 1)
                    ])
                  ]),
                  (dailyNoteItems.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("ul", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dailyNoteItems.value.slice(0, _MAX_DISPLAY_COUNT), (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              class: "item-daily-note-row",
                              key: item.id
                            }, [
                              _createElementVNode("p", _hoisted_33, _toDisplayString(item.content), 1),
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("span", _hoisted_35, _toDisplayString(formatDate(item.date, "YYYY年M月D日")), 1),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["row-bottom-category", item.categoryClass])
                                }, _toDisplayString(item.categoryLabel), 3)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          (dailyNoteItems.value.length > _MAX_DISPLAY_COUNT)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: onDailyNoteMore,
                                class: "item-daily-note-more-button",
                                type: "button"
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.$t("myreport_graph_button_symptom_more")) + " ", 1),
                                _cache[3] || (_cache[3] = _createElementVNode("img", {
                                  src: "/server/necs/images/arrow-right_icon.png",
                                  alt: ""
                                }, null, -1))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (
              _unref(dayjs)(selectedDate.value).isBefore(_unref(dayjs)().subtract(6, 'day'), 'day')
            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t("myreport_calendar_message_notrecord_symptom")), 1)
                        ]))
                      : (_unref(dayjs)(selectedDate.value).isAfter(_unref(dayjs)(), 'day'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t("myreport_calendar_message_notrecord_symptom")), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("p", {
                              class: "item-unrecorded-text",
                              innerHTML: _ctx.$t('myreport_calendar_message_norecord_symptom')
                            }, null, 8, _hoisted_42),
                            _createElementVNode("button", {
                              class: "item-unrecorded-button",
                              onClick: onClickRecordSymptom
                            }, _toDisplayString(_ctx.$t("myreport_calendar_button_norecord_symptom")), 1),
                            _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t("myreport_calendar_message_norecord_symptom_note")), 1)
                          ]))
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.$t("myreport_calendar_label_feeling")), 1)
                    ])
                  ]),
                  (dailyFeelings.value.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_48, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dailyFeelings.value, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: item.iconValue,
                            class: "item-feeling-row"
                          }, [
                            _createElementVNode("img", {
                              src: getFeelingIcon(item.iconValue)
                            }, null, 8, _hoisted_49),
                            _createElementVNode("p", _hoisted_50, _toDisplayString(getFeelingLabel(item.iconValue)), 1)
                          ]))
                        }), 128))
                      ]))
                    : (
              _unref(dayjs)(selectedDate.value).isBefore(_unref(dayjs)().subtract(6, 'day'), 'day')
            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t("myreport_calendar_message_notrecord_feeling")), 1)
                        ]))
                      : (_unref(dayjs)(selectedDate.value).isAfter(_unref(dayjs)(), 'day'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.$t("myreport_calendar_message_notrecord_feeling")), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _createElementVNode("p", {
                              class: "item-unrecorded-text",
                              innerHTML: _ctx.$t('myreport_calendar_message_norecord_feeling')
                            }, null, 8, _hoisted_56),
                            _createElementVNode("button", {
                              class: "item-unrecorded-button",
                              onClick: onClickRecordFeeling
                            }, _toDisplayString(_ctx.$t("myreport_calendar_button_norecord_feeling")), 1),
                            _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.$t("myreport_calendar_message_norecord_feeling_note")), 1)
                          ]))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_unref(errorDialogSet).show)
        ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 0 }, _unref(errorDialogSet), {
            onOk: _unref(errorDialogSet).close,
            onCancel: _unref(errorDialogSet).close
          }), null, 16, ["onOk", "onCancel"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})